import { EnumChatAppType, EnumUserChatRole } from '../../constants/enum';

import DriverAvatar from '../../assets/common/static/icons/chat/driver_default_avt.png';
import CcAvatar from '../../assets/common/static/icons/chat/cc_default_avt.png';

export const checkChannelIsLoading = (channel) => {
  const { chatTabData } = channel;
  return Object.values(chatTabData).reduce(
    (isLoading, tab) => isLoading || tab.isLoading,
    false,
  );
};

export const checkChannelHasUnreadMessage = (channel) => {
  const { chatTabData } = channel;
  return Object.values(chatTabData).reduce(
    (hasNewMessage, tab) => hasNewMessage || tab.hasUnreadMessage,
    false,
  );
};

export const checkListChannelHasUnreadMessage = chatChannelData =>
  Object.values(chatChannelData).reduce(
    (hasNewMessage, channel) =>
      hasNewMessage || checkChannelHasUnreadMessage(channel),
    false,
  );

export const checkHasUnreadMessage = (chat) => {
  const { chatChannelData, chatChannelListOrder } = chat;
  return chatChannelListOrder.reduce(
    (hasNewMessage, channelId) =>
      hasNewMessage || checkChannelHasUnreadMessage(chatChannelData[channelId]),
    false,
  );
};

export const splitReadUnreadMessage = (appType, userSeenStatus, messages) => {
  let readMessages = messages;
  let unreadMessages = [];

  const splitReadUnreadMessageNowShip = () => {
    const {
      [EnumUserChatRole.USER.id]: lastUserSeenMessage,
      ...rest
    } = userSeenStatus;
    if (lastUserSeenMessage) {
      const unreadMessageIndex =
        messages.findIndex(
          message =>
            message.id === lastUserSeenMessage.lastMessageId ||
            message.clientMessageId === lastUserSeenMessage.lastMessageId,
        ) + 1;
      if (unreadMessageIndex !== -1) {
        readMessages = messages.slice(0, unreadMessageIndex);
        unreadMessages = messages.slice(unreadMessageIndex);
      }
    }
    return {
      readMessages,
      unreadMessages,
      otherSeenStatus: Object.values(rest),
    };
  };

  switch (appType) {
    case EnumChatAppType.NOW_SHIP.id: {
      return splitReadUnreadMessageNowShip();
    }
    default:
      return { readMessages, unreadMessages, otherSeenStatus: [] };
  }
};

export const getAvatarChat = (userRole) => {
  switch (userRole) {
    case EnumUserChatRole.SHIPPER.id: {
      return DriverAvatar;
    }
    case EnumUserChatRole.CALL_CENTER.id: {
      return CcAvatar;
    }
    default:
      return CONFIG.DEFAULT_CHAT_AVATAR;
  }
};



// WEBPACK FOOTER //
// ./foody/src/pages/ChatBox/routines.js